var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"material-icons-outlined leading-none",class:[_vm.color, _vm.sizeClasses],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.icon))])
}
var staticRenderFns = []

export { render, staticRenderFns }